import { SET_EXTERNAL_USERS_SHARE_DIALOG_OPEN, SET_SHARE_ITEM_DATA } from "redux/constants/portal";

export const setExternalUsersShareDialogOpen = (payload) => ({
  type: SET_EXTERNAL_USERS_SHARE_DIALOG_OPEN,
  payload,
});

export const setShareItemData = (payload) => ({
  type: SET_SHARE_ITEM_DATA,
  payload,
});
